import { executeRequest, Request } from '@jfs/network'
import { mimeTypes } from '../utils/constants'
import { APIEndPoints } from './APIEndPoints'
import { getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  downloadFile(response)
  return response
}

const downloadFile = (resp: any) => {
  let contentType = resp.headers['content-type']
  if (mimeTypes.get(contentType) === undefined) {
    return
  } else {
    const blob = new Blob([resp?.data], { type: contentType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.href = url
    a.download = `${new Date().getTime()}${mimeTypes.get(contentType)}`
    a.click()
    window.URL.revokeObjectURL(url)
    document.body.removeChild(a)
  }
}

const exportFile = (tokens: any, reqBody: any) => {
  const request: Request<{}> = {
    apiPath: getUrl(APIEndPoints.export),
    method: 'POST',
    config: sitConfig(tokens),
    body: reqBody,
    responseType: 'arraybuffer',
  }

  return executeRequest(request)
    .then((resp) => responseParser(resp))
    .catch((error) => {
      throw error
    })
}

export { exportFile }
